import { render } from "./SkeletonStats.vue?vue&type=template&id=7b0689be&scoped=true"
import script from "./SkeletonStats.vue?vue&type=script&lang=js"
export * from "./SkeletonStats.vue?vue&type=script&lang=js"

import "./SkeletonStats.vue?vue&type=style&index=0&id=7b0689be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0689be"]])

export default __exports__